var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var MAX_SESSION_AGE_MS = 6 * 60 * 60 * 1000; // 6 hours
var QuestionnaireTimer = /** @class */ (function () {
    function QuestionnaireTimer() {
        this.timings = {};
        this.storageKey = 'questionnaire_timings';
        this.loadTimings();
    }
    QuestionnaireTimer.prototype.loadTimings = function () {
        var stored = localStorage.getItem(this.storageKey);
        if (stored) {
            try {
                this.timings = JSON.parse(stored);
            }
            catch (e) {
                console.error('Error loading questionnaire timings:', e);
                this.timings = {};
            }
        }
    };
    QuestionnaireTimer.prototype.saveTimings = function () {
        localStorage.setItem(this.storageKey, JSON.stringify(this.timings));
    };
    QuestionnaireTimer.prototype.discardIfStale = function () {
        var startTimes = Object.values(this.timings).map(function (t) { return t.startTime; });
        if (startTimes.length === 0) {
            return;
        }
        var earliestStart = Math.min.apply(Math, startTimes);
        if (Date.now() - earliestStart > MAX_SESSION_AGE_MS) {
            console.warn('⏱️ Discarding stale questionnaire timings from an abandoned attempt');
            this.timings = {};
        }
    };
    QuestionnaireTimer.prototype.startSection = function (domainName) {
        var _a;
        this.discardIfStale();
        var existingDuration = (_a = this.timings[domainName]) === null || _a === void 0 ? void 0 : _a.duration;
        this.timings[domainName] = {
            startTime: Date.now(),
            duration: existingDuration,
        };
        this.saveTimings();
        console.log("\u23F1\uFE0F Started timing: ".concat(domainName));
    };
    QuestionnaireTimer.prototype.endSection = function (domainName) {
        var timing = this.timings[domainName];
        if (!timing) {
            console.warn("No start time found for ".concat(domainName));
            return 0;
        }
        var visitDuration = (Date.now() - timing.startTime) / 1000;
        var totalDuration = (timing.duration || 0) + visitDuration;
        this.timings[domainName].duration = totalDuration;
        this.saveTimings();
        console.log("\u23F1\uFE0F Completed ".concat(domainName, " in ").concat(visitDuration.toFixed(2), "s this visit (").concat(totalDuration.toFixed(2), "s total)"));
        return totalDuration;
    };
    QuestionnaireTimer.prototype.getTotalTime = function () {
        var total = Object.values(this.timings).reduce(function (sum, timing) {
            return sum + (timing.duration || 0);
        }, 0);
        console.group('📊 TOTAL QUESTIONNAIRE TIME');
        console.log('Sections completed:', Object.values(this.timings).filter(function (t) { return t.duration; }).length);
        console.log('Total time (seconds):', total.toFixed(2));
        console.log('Total time (minutes):', (total / 60).toFixed(2));
        console.log('Section breakdown:');
        Object.entries(this.timings).forEach(function (_a) {
            var domain = _a[0], timing = _a[1];
            if (timing.duration) {
                console.log("  ".concat(domain, ": ").concat(timing.duration.toFixed(2), "s (").concat((timing.duration / 60).toFixed(2), " min)"));
            }
        });
        console.groupEnd();
        return total;
    };
    QuestionnaireTimer.prototype.getSectionTime = function (domainName) {
        var _a;
        return ((_a = this.timings[domainName]) === null || _a === void 0 ? void 0 : _a.duration) || 0;
    };
    QuestionnaireTimer.prototype.getAllTimings = function () {
        return __assign({}, this.timings);
    };
    QuestionnaireTimer.prototype.clearTimings = function () {
        this.timings = {};
        localStorage.removeItem(this.storageKey);
        console.log('🧹 Cleared questionnaire timings');
    };
    // Call this when a questionnaire is fully completed
    QuestionnaireTimer.prototype.onQuestionnaireComplete = function () {
        var totalTime = this.getTotalTime();
        var allTimings = this.getAllTimings();
        return {
            totalSeconds: totalTime,
            sections: allTimings,
        };
    };
    return QuestionnaireTimer;
}());
// Export singleton instance
export var questionnaireTimer = new QuestionnaireTimer();
